import React from 'react';
import '../template-file-css/document-file-template.css';


export const NWBH_MasterServicePlan = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='NWBH_MasterServicePlan' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Medicaid Current as of:</span>
                            <input type='text' id='txtMedicaidCurrent' name='txtMedicaidCurrent' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date</span>
                            <input type='date' id='txtDate' name='txtDate' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbMedicaidClient' name='cbMedicaidClient' className='add-only' value='MedicaidClient' /> Medicaid Client &nbsp;
                            <input type='checkbox' id='cbNonMedicaidClient' name='cbNonMedicaidClient' className='add-only' value='NonMedicaidClient' /> Non-Medicaid Client
                        </td>
                    </tr>
                </table>


                <p className='w-750'><h3>Diagnosis Code</h3></p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>AXIS I:</span>
                            <input type='text' id='txtAxisI' name='txtAxisI' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>AXIS II:</span>
                            <input type='text' id='txttxtAxisII' name='txttxtAxisII' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>AXIS III:</span>
                            <input type='text' id='txtAxisIII' name='txtAxisIII' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>AXIS IV:</span>
                            <input type='text' id='txtAxisIV' name='txtAxisIV' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>AXIS V(GAF):</span>
                            <input type='text' id='txtAxisV' name='txtAxisV' className='add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>AXIS I Diagnosis Narrative:</span>
                    <textarea id='txtNarrative' name='txtNarrative' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Client Long-term View: </span>
                    <textarea id='txtTermView' name='txtTermView' className='add-only'></textarea>
                </p>

                <p className='w-750'><h3>Input from Family Members (if applicable): </h3></p>

                <table>
                    <tr>
                        <td className='w-400'><span className='eleHeader'>CLIENT PROBLEM/NEEDS FROM ASSESSMENT</span></td>
                        <td className='w-350'><span className='eleHeader'>CLIENT GOALS</span></td>
                    </tr>
                    <tr>
                        <td className='w-400'><input type='text' id='txtClientProblem_1' name='txtClientProblem_1' className='add-only' ></input></td>
                        <td className='w-350'><input type='text' id='txtClientGoal_1' name='txtClientGoal_1' className='add-only' ></input></td>
                    </tr>
                    <tr>
                        <td className='w-400'><input type='text' id='txtClientProblem_2' name='txtClientProblem_2' className='add-only' ></input></td>
                        <td className='w-350'><input type='text' id='txtClientGoal_2' name='txtClientGoal_2' className='add-only' ></input></td>
                    </tr>
                    <tr>
                        <td className='w-400'><input type='text' id='txtClientProblem_3' name='txtClientProblem_3' className='add-only' ></input></td>
                        <td className='w-350'><input type='text' id='txtClientGoal_3' name='txtClientGoal_3' className='add-only' ></input></td>
                    </tr>
                    <tr>
                        <td className='w-400'><input type='text' id='txtClientProblem_4' name='txtClientProblem_4' className='add-only' ></input></td>
                        <td className='w-350'><input type='text' id='txtClientGoal_4' name='txtClientGoal_4' className='add-only' ></input></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>TARGET DATE</span></td>
                        <td className='w-100'><span className='eleHeader'>GOAL #</span></td>
                        <td className='w-350'>
                            <span className='eleHeader'>CLIENT OBJECTIVES </span>
                            <span className='small'>(Indicate measurable changes in target behavior. <br />Example 1.1 or 1.2)</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'>TREATMENT PROVIDER</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_1' name='txtTargetDate_1' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtGoal_1' name='txtGoal_1' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtClientObjectives_1' name='txtClientObjectives_1' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtTreatmentProvider_1' name='txtTreatmentProvider_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_2' name='txtTargetDate_2' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtGoal_2' name='txtGoal_2' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtClientObjectives_2' name='txtClientObjectives_2' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtTreatmentProvider_2' name='txtTreatmentProvider_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_3' name='txtTargetDate_3' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtGoal_3' name='txtGoal_3' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtClientObjectives_3' name='txtClientObjectives_3' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtTreatmentProvider_3' name='txtTreatmentProvider_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_4' name='txtTargetDate_4' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtGoal_4' name='txtGoal_4' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtClientObjectives_4' name='txtClientObjectives_4' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtTreatmentProvider_4' name='txtTreatmentProvider_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_5' name='txtTargetDate_5' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtGoal_5' name='txtGoal_5' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtClientObjectives_5' name='txtClientObjectives_5' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtTreatmentProvider_5' name='txtTreatmentProvider_5' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_6' name='txtTargetDate_6' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtGoal_6' name='txtGoal_6' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtClientObjectives_6' name='txtClientObjectives_6' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtTreatmentProvider_6' name='txtTreatmentProvider_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_7' name='txtTargetDate_7' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtGoal_7' name='txtGoal_7' className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtClientObjectives_7' name='txtClientObjectives_7' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtTreatmentProvider_7' name='txtTreatmentProvider_7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_8' name='txtTargetDate_8' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtGoal_8' name='txtGoal_8' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtClientObjectives_8' name='txtClientObjectives_8' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtTreatmentProvider_8' name='txtTreatmentProvider_8' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_9' name='txtTargetDate_9' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtGoal_9' name='txtGoal_9' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtClientObjectives_9' name='txtClientObjectives_9' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtTreatmentProvider_9' name='txtTreatmentProvider_9' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_10' name='txtTargetDate_10' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtGoal_10' name='txtGoal_10' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtClientObjectives_10' name='txtClientObjectives_10' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtTreatmentProvider_10' name='txtTreatmentProvider_10' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_11' name='txtTargetDate_11' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtGoal_11' name='txtGoal_11' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtClientObjectives_11' name='txtClientObjectives_11' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtTreatmentProvider_11' name='txtTreatmentProvider_11' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_12' name='txtTargetDate_12' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtGoal_12' name='txtGoal_12' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtClientObjectives_12' name='txtClientObjectives_12' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtTreatmentProvider_12' name='txtTreatmentProvider_12' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_13' name='txtTargetDate_13' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtGoal_13' name='txtGoal_13' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtClientObjectives_13' name='txtClientObjectives_13' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtTreatmentProvider_13' name='txtTreatmentProvider_13' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_14' name='txtTargetDate_14' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtGoal_14' name='txtGoal_14' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtClientObjectives_14' name='txtClientObjectives_14' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtTreatmentProvider_14' name='txtTreatmentProvider_14' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_15' name='txtTargetDate_15' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtGoal_15' name='txtGoal_15' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtClientObjectives_15' name='txtClientObjectives_15' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtTreatmentProvider_15' name='txtTreatmentProvider_15' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_16' name='txtTargetDate_16' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtGoal_16' name='txtGoal_16' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtClientObjectives_16' name='txtClientObjectives_16' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtTreatmentProvider_16' name='txtTreatmentProvider_16' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_17' name='txtTargetDate_17' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtGoal_17' name='txtGoal_17' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtClientObjectives_17' name='txtClientObjectives_17' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtTreatmentProvider_17' name='txtTreatmentProvider_17' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_18' name='txtTargetDate_18' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtGoal_18' name='txtGoal_18' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtClientObjectives_18' name='txtClientObjectives_18' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtTreatmentProvider_18' name='txtTreatmentProvider_18' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_19' name='txtTargetDate_19' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtGoal_19' name='txtGoal_19' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtClientObjectives_19' name='txtClientObjectives_19' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtTreatmentProvider_19' name='txtTreatmentProvider_19' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_20' name='txtTargetDate_20' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtGoal_20' name='txtGoal_20' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtClientObjectives_20' name='txtClientObjectives_20' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtTreatmentProvider_20' name='txtTreatmentProvider_20' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_21' name='txtTargetDate_21' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtGoal_21' name='txtGoal_21' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtClientObjectives_21' name='txtClientObjectives_21' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtTreatmentProvider_21' name='txtTreatmentProvider_21' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_22' name='txtTargetDate_22' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtGoal_22' name='txtGoal_22' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtClientObjectives_22' name='txtClientObjectives_22' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtTreatmentProvider_22' name='txtTreatmentProvider_22' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_23' name='txtTargetDate_23' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtGoal_23' name='txtGoal_23' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtClientObjectives_23' name='txtClientObjectives_23' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtTreatmentProvider_23' name='txtTreatmentProvider_23' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_24' name='txtTargetDate_24' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtGoal_24' name='txtGoal_24' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtClientObjectives_24' name='txtClientObjectives_24' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtTreatmentProvider_24' name='txtTreatmentProvider_24' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_25' name='txtTargetDate_25' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtGoal_25' name='txtGoal_25' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtClientObjectives_25' name='txtClientObjectives_25' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtTreatmentProvider_25' name='txtTreatmentProvider_25' className='add-only' /></td>
                    </tr>
                </table>
                <hr />
                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>OBJECTIVE #</span></td>
                        <td className='w-450'><span className='eleHeader'>TERMINATION CRITERIA</span></td>
                        <td className='w-150'><span className='eleHeader'>DATE TERMINATED</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_1' name='txtObjective_1' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_1' name='txtTerminationCriteria_1' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_1' name='txtDateTerminated_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_2' name='txtObjective_2' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_2' name='txtTerminationCriteria_2' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_2' name='txtDateTerminated_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_3' name='txtObjective_3' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_3' name='txtTerminationCriteria_3' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_3' name='txtDateTerminated_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_4' name='txtObjective_4' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_4' name='txtTerminationCriteria_4' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_4' name='txtDateTerminated_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_5' name='txtObjective_5' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_5' name='txtTerminationCriteria_5' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_5' name='txtDateTerminated_5' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_6' name='txtObjective_6' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_6' name='txtTerminationCriteria_6' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_6' name='txtDateTerminated_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_7' name='txtObjective_7' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_7' name='txtTerminationCriteria_7' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_7' name='txtDateTerminated_7' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_8' name='txtObjective_8' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_8' name='txtTerminationCriteria_8' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_8' name='txtDateTerminated_8' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_9' name='txtObjective_9' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_9' name='txtTerminationCriteria_9' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_9' name='txtDateTerminated_9' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_10' name='txtObjective_10' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_10' name='txtTerminationCriteria_10' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_10' name='txtDateTerminated_10' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_11' name='txtObjective_11' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_11' name='txtTerminationCriteria_11' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_11' name='txtDateTerminated_11' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_12' name='txtObjective_12' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_12' name='txtTerminationCriteria_12' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_12' name='txtDateTerminated_12' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_13' name='txtObjective_13' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_13' name='txtTerminationCriteria_13' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_13' name='txtDateTerminated_13' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_14' name='txtObjective_14' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_14' name='txtTerminationCriteria_14' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_14' name='txtDateTerminated_14' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_15' name='txtObjective_15' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_15' name='txtTerminationCriteria_15' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_15' name='txtDateTerminated_15' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_16' name='txtObjective_16' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_16' name='txtTerminationCriteria_16' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_16' name='txtDateTerminated_16' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_17' name='txtObjective_17' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_17' name='txtTerminationCriteria_17' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_17' name='txtDateTerminated_17' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_18' name='txtObjective_18' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_18' name='txtTerminationCriteria_18' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_18' name='txtDateTerminated_18' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_19' name='txtObjective_19' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_19' name='txtTerminationCriteria_19' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_19' name='txtDateTerminated_19' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_20' name='txtObjective_20' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_20' name='txtTerminationCriteria_20' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_20' name='txtDateTerminated_20' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_21' name='txtObjective_21' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_21' name='txtTerminationCriteria_21' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_21' name='txtDateTerminated_21' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_22' name='txtObjective_22' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_22' name='txtTerminationCriteria_22' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_22' name='txtDateTerminated_22' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_23' name='txtObjective_23' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_23' name='txtTerminationCriteria_23' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_23' name='txtDateTerminated_23' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_24' name='txtObjective_24' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_24' name='txtTerminationCriteria_24' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_24' name='txtDateTerminated_24' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_25' name='txtObjective_25' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_25' name='txtTerminationCriteria_25' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_25' name='txtDateTerminated_25' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_26' name='txtObjective_26' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_26' name='txtTerminationCriteria_26' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_26' name='txtDateTerminated_26' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_27' name='txtObjective_27' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_27' name='txtTerminationCriteria_27' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_27' name='txtDateTerminated_27' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_28' name='txtObjective_28' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_28' name='txtTerminationCriteria_28' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_28' name='txtDateTerminated_28' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_29' name='txtObjective_29' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_29' name='txtTerminationCriteria_29' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_29' name='txtDateTerminated_29' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtObjective_30' name='txtObjective_30' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtTerminationCriteria_30' name='txtTerminationCriteria_30' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateTerminated_30' name='txtDateTerminated_30' className='add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>FOR PROBLEM NUMBERS</span>
                            <input type='text' id='txtNumber' name='txtNumber' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>DATED</span>
                            <input type='date' id='txtDated' name='txtDated' className='add-only' />
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-300'><span className='eleHeader'>SERVICE TYPES</span></td>
                        <td className='w-150'><span className='eleHeader'>FREQUENCY</span></td>
                        <td className='w-150'><span className='eleHeader'>LENGTH OF SESSION</span></td>
                        <td className='w-150'><span className='eleHeader'>DURATION OF TREATMENT</span></td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>[ ]ASSESSMENT/REVIEW</span></td>
                        <td className='w-150'><input type='text' id='txtFrequency_1' name='txtFrequency_1' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtLength_1' name='txtLength_1' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDuration_1' name='txtDuration_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>[ ]INDIVIDUAL THERAPY</span></td>
                        <td className='w-150'><input type='text' id='txtFrequency_2' name='txtFrequency_2' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtLength_2' name='txtLength_2' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDuration_2' name='txtDuration_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>[ ]GROUP THERAPY</span></td>
                        <td className='w-150'><input type='text' id='txtFrequency_3' name='txtFrequency_3' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtLength_3' name='txtLength_3' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDuration_3' name='txtDuration_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>[ ]ITOS</span></td>
                        <td className='w-150'><input type='text' id='txtFrequency_4' name='txtFrequency_4' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtLength_4' name='txtLength_4' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDuration_4' name='txtDuration_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>[ ]MEDICATION MANAGEMENT/ MONITORING</span></td>
                        <td className='w-150'><input type='text' id='txtFrequency_5' name='txtFrequency_5' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtLength_5' name='txtLength_5' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDuration_5' name='txtDuration_5' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>[ ]PSYCHIATRIC EVALUATION/UPDATE</span></td>
                        <td className='w-150'><input type='text' id='txtFrequency_6' name='txtFrequency_6' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtLength_6' name='txtLength_6' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDuration_6' name='txtDuration_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>[ ]COLLATERAL WITH</span></td>
                        <td className='w-150'><input type='text' id='txtFrequency_7' name='txtFrequency_7' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtLength_7' name='txtLength_7' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDuration_7' name='txtDuration_7' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>[ ]CASE MANAGEMENT/ MONITORING</span></td>
                        <td className='w-150'><input type='text' id='txtFrequency_8' name='txtFrequency_8' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtLength_8' name='txtLength_8' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDuration_8' name='txtDuration_8' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>[ ]ADL SKILLS, PSYCHOSOCIAL REHAB AND COUNSELING</span></td>
                        <td className='w-150'><input type='text' id='txtFrequency_9' name='txtFrequency_9' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtLength_9' name='txtLength_9' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDuration_9' name='txtDuration_9' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>[ ]DAY TREATMENT SERVICES</span></td>
                        <td className='w-150'><input type='text' id='txtFrequency_10' name='txtFrequency_10' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtLength_10' name='txtLength_10' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDuration_10' name='txtDuration_10' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>[ ]FAMILY THERAPY</span></td>
                        <td className='w-150'><input type='text' id='txtFrequency_11' name='txtFrequency_11' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtLength_11' name='txtLength_11' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDuration_11' name='txtDuration_11' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>[ ]</span></td>
                        <td className='w-150'><input type='text' id='txtFrequency_12' name='txtFrequency_12' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtLength_12' name='txtLength_12' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDuration_12' name='txtDuration_12' className='add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Referral Agencies</span>
                            <input type='text' id='txtReferralAgencies' name='txtReferralAgencies' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Agency Phone Number</span>
                            <input type='text' id='txtAgencyPhoneNumber' name='txtAgencyPhoneNumber' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>I/We/have participated in the development of this plan.</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Client</span>
                            <input type='text' id='txtClient' name='txtClient' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Parent or Guardian</span>
                            <input type='text' id='txtGuardian' name='txtGuardian' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Case Manager</span>
                            <input type='text' id='txtCaseManager_1' name='txtCaseManager_1' className='add-only w-350 custom-add-only' /> &nbsp;
                            <input type='text' id='txtCaseManager_2' name='txtCaseManager_2' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span><b>Client received a copy of his/her plan </b></span>
                            <input type='radio' id='rbReceived_Yes' name='rbReceived' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbReceived_No' name='rbReceived' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>Program Supervisor or Clinical Director</span>
                            <input type='text' id='txtClinicalDirector' name='txtClinicalDirector' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Service Plan Review date</span>
                            <input type='date' id='txtReviewDate' name='txtReviewDate' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>Title:</span>
                            <input type='text' id='txtTitle' name='txtTitle' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date</span>
                            <input type='date' id='txtSupervisorDate' name='txtSupervisorDate' className='add-only' />
                        </td>
                    </tr>
                </table>

            </div>
        </form>

    )
}

